import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Icon, Table, Card, Popup, Dropdown, Loader} from 'semantic-ui-react';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {dateFormatShow} from '../../../common/constants/datesFormat';
import {pageSizes} from '../../../common/constants/lists';
import {Actions} from '../../../common/actions';
import TablePaginator from '../../../common/components/tablePaginator';

class TableProvidersOrdersManagement extends Component {
  constructor(props) {
    super(props);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
    this.onPageClick = this.onPageClick.bind(this);
  }

  componentDidMount() {
    this.props.changeProvidersOrdersManagementListPageSize(pageSizes[1].value);
  }

  onPageClick(value) {
    this.props.changeProvidersOrdersManagementListPage(value);
  }

  onPageSizeClick(event, data) {
    this.props.changeProvidersOrdersManagementListPageSize(data.value);
  }

  handleViewDetailClick(order) {
    this.props.viewProviderOrderDetail(order);
  }

  render() {
    return (
      <Card fluid raised>
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>Proveedor</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>
                Numero Pedido
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>
                Fecha Pedido
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>
                Cantidad Solicitada
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>
                Cantidad Atendida
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>%</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Acciones</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{this.renderLoaderOrOrders()}</Table.Body>

          {this.renderPagination()}
        </Table>
      </Card>
    );
  }

  renderLoaderOrOrders() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderOrders();
  }

  renderOrders() {
    const {orders} = this.props;

    if (!orders.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={7}>
            No hay pedidos disponibles
          </Table.Cell>
        </Table.Row>
      );
    }

    return orders.map((element, index) => {
      const dateFormatted = element.creationDate ?
        moment(element.creationDate).format(dateFormatShow) :
        '';
      return (
        <Table.Row key={index} negative={this.showAlert(element)}>
          <Table.Cell textAlign='center'>{element.providerName}</Table.Cell>
          <Table.Cell textAlign='center'>{element.orderCode}</Table.Cell>
          <Table.Cell textAlign='center'>
            {dateFormatted.toUpperCase()}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {element.orderQuantity || 0}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {element.attendedQuantity || 0}
          </Table.Cell>
          <Table.Cell textAlign='center'>{`${getNumericValue(
            element.attentionPercentage,
            2
          )}%`}</Table.Cell>
          <Table.Cell textAlign='center'>
            {this.renderDetailIcon(element)}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  showAlert(element) {
    return (
      !!element.orderQuantity &&
      Boolean(element.isDelayed) &&
      element.attentionPercentage < 100
    );
  }

  renderDetailIcon(element) {
    if (!element.orderQuantity) {
      return null;
    }

    return (
      <Popup
        inverted
        trigger={
          <Icon
            link
            name='eye'
            color='blue'
            size='large'
            onClick={() => this.handleViewDetailClick(element)}
          />
        }
        content='Detalle'
        position='top center'
      />
    );
  }

  renderPagination() {
    const {pageNumber, pageSize, totalItems, loading} = this.props;

    if (totalItems <= pageSize || loading) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.providersOrdersManagement.loading,
    'orders': state.providersOrdersManagement.listByPage,
    'pageNumber': state.providersOrdersManagement.pageNumber,
    'pageSize': state.providersOrdersManagement.pageSize,
    'totalItems': state.providersOrdersManagement.list.length,
  };
};

const {
  viewProviderOrderDetail,
  changeProvidersOrdersManagementListPage,
  changeProvidersOrdersManagementListPageSize,
} = Actions;

export default connect(mapStateToProps, {
  viewProviderOrderDetail,
  changeProvidersOrdersManagementListPage,
  changeProvidersOrdersManagementListPageSize,
})(TableProvidersOrdersManagement);
